/* eslint-disable import/no-dynamic-require */
import React, { useState } from "react"
import classnames from "classnames"

import styles from "./index.scss"
import cityStories from "./stories"

const OwnerStory = () => {
  const [overCity, setOverCity] = useState("")
  const handleCityOver = (e) => {
    const { city } = e.target.attributes
    const cityElt = window.document.getElementById(city.value)
    cityElt && cityElt.setAttribute("src", cityElt.getAttribute("data-src"))
    city && setOverCity(city.value)
  }
  return (
    <div className={classnames(styles["r-story"], "clearfix")}>
      <div className="r-story-logo">车主故事</div>
      <div
        className="r-story-map"
        onMouseLeave={() => {
          setOverCity("")
        }}
      >
        {cityStories.map(item => (
          <span className={`city city-${item.city}`} key={item.city}>
            <div
              className={`landmark-bg ${overCity === item.city ? "over" : ""}`}
            />
            <div
              className={`landmark ${overCity === item.city ? "over" : ""}`}
              city={item.city}
              onFocus={() => 0}
              onMouseOver={handleCityOver}
            >
              {item.cityName}
            </div>
            {/* hover 展示的内容区域 */}
            <div
              className={`city-content-big city-content-${item.city} ${
                overCity === item.city ? "over" : ""
              }`}
            >
              <div className="city-content">
                <div className="seller-intro">
                  <div className="seller-intro-top clearfix">
                    <p className="seller-place">{item.sellerPlace}</p>
                    <p className="seller-car-type">{item.sellerCarType}</p>
                    <p className="seller-name">{item.sellerName}</p>
                  </div>
                  <div className="seller-intro-bottom">{item.sellerSay}</div>
                </div>
                <div className="seller-img">
                  <div className="seller-pic">
                    <a
                      href="//bbs.renrenche.com/forum.php?mod=forumdisplay&fid=51&filter=digest&digest=1&typeid=17"
                      target="_blank"
                    >
                      <img
                        id={item.city}
                        className="pic"
                        data-src={require(`../../../../assets/img/sell/city/${item.city}.png`)}
                        alt={item.city}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </span>
        ))}
      </div>
    </div>
  )
}

export default OwnerStory
